const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/iam.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const LOAD_IAM_USER_PATIENT_LINK = kisapiActionTypes('LOAD_IAM_USER_PATIENT_LINK');
export const LOAD_IAM_TOKEN = kisapiActionTypes('LOAD_IAM_TOKEN');

export function actionLoadSignedTokenForIAM() {
    return createPatapiCall(LOAD_IAM_TOKEN, 'patient/iam/registerURL', HttpMethod.GET);
}

export function actionLoadIAMUserPatientLink() {
    const endpoint = `patient/iam/checkLinkage`;
    return createPatapiCall(LOAD_IAM_USER_PATIENT_LINK, endpoint, HttpMethod.GET);
}
